import React from "react";
import SelectOption from "./components/SelectOption";

const classificationTypeOptions = [
  {
    value: "leanOn",
    label: "リーブオン"
  },
  {
    value: "leanOff",
    label: "リンスオフ（洗い流しあり・希釈必要なもの）"
  },
]

function SelectClassification(props) {
  const { selectedValue, onSelect, isReadonly } = props;

  const handleSelect = (value) => {
    onSelect(selectedValue === value ? '' : value)
  }

  return (
    <div className="">
      <div className="flex flex-col gap-2 h-full p-2">
        <SelectOption
          label={<p className="w-full text-start px-3">
            {classificationTypeOptions[0].label}
          </p>}
          value={classificationTypeOptions[0].value}
          onSelect={handleSelect}
          isSelected={selectedValue === classificationTypeOptions[0].value}
          isReadonly={isReadonly}
          width={'250px'}
        />
        <SelectOption
          label={<p className="w-full text-start px-3">
            {classificationTypeOptions[1].label}
          </p>}
          value={classificationTypeOptions[1].value}
          onSelect={handleSelect}
          isSelected={selectedValue === classificationTypeOptions[1].value}
          isReadonly={isReadonly}
          width={'250px'}
          note={'※試験濃度·希釈溶媒のご記載をお願いします。'}
        />
      </div>
    </div>
  );
}

export default SelectClassification;
